<template>
    <div class="viewChartPage">
        This is a viewChart.
    </div>
</template>

<script>
export default {
    name: 'viewChart',
    props: {

    },
    data () {
        return {

        }
    },

    methods: {

    },
    created () {

    }
}
</script>

